import { RemoteGetStudentsFrequencyReport } from 'data/usecases';
import { GetStudentsFrequencyReportUseCaseInterface } from 'domain/usecases';
import { makeApiUrlStudentsFrequencyReport } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetStudentsFrequencyReport =
  (): GetStudentsFrequencyReportUseCaseInterface =>
    new RemoteGetStudentsFrequencyReport(
      makeApiUrlStudentsFrequencyReport(),
      makeAxiosHttpClient(),
    );
